import Header from "../../components/header";
import { Container, HeaderSection, ListContainer } from "../style";
import CreateBoardModal from "../../components/modals/createBoardModal";
import PurchaseSeatLogs from "../../components/paymentHistory/PurchaseSeatLogs";

const PurchaseSeatLogsPage = () => {
  const content = {
    tabTitle: "Seats History",
    tabSubTitle: `Purchase Seats History`,
  };
  return (
    <Container>
      <HeaderSection>
        <Header content={content} hideCreateButton={true} />
        <ListContainer>
          <PurchaseSeatLogs />
        </ListContainer>
      </HeaderSection>
      <CreateBoardModal />
    </Container>
  );
};

export default PurchaseSeatLogsPage;
